export default {
    primary: '#1c2856',
    secondary: 'white',
    accent: '#8c9eff',
    error: '#b71c1c',
    success: '#83b33f',
    edit: '#ff851a',
    mainTheme: '#13181b',
    background: '#13181b',
    sectionMenu: '#b0d141',
    navbar: '#1c2856',
    sidebar: '#1c2856',

    yellowProp: '#F2C300'

}
